<app-list-billing [chunkBookingBilling]="chunkBookingBilling" [isGuide]="true" [isGuideBilling]="true" (findBillingTrigger)="onFindBillingTrigger($event)"></app-list-billing>
<app-message-panel [preloading]="true"></app-message-panel>